export default __webpack_public_path__ + "static/media/ens-monthly-roundup-january-2023.cebcb433.md";